import {FETCH_PRODUCT_SUCCESS, FETCH_DETAIL_PRODUCT_SUCCESS} from '../actions/actionType'

const initialState = {
  products: [],
  detailProduct: {}
}

function productReducers(state = initialState, action) {
  switch (action.type) {
    case FETCH_PRODUCT_SUCCESS:
      return { 
        ...state,
        products: action.payload
       }
    case FETCH_DETAIL_PRODUCT_SUCCESS:
      return { 
        ...state,
        detailProduct: action.payload
       }
    default:
      return state
  }
}

export default productReducers